import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import css from "./index.module.scss";
import { Api } from "@uikit/service/api";
import { useEffect, useMemo } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { AISaasLayout } from "../AISaasLayout";
import { AISaasProvider, useAISaasContainer } from "../container";
import { AiSaasOutputList } from "../AISaasOutput";
import { AISaasHeader } from "../AiSaasHeader";
import PreviewHeaderView from "@uiview/views/PreviewHeader/PreviewHeaderView";
import { AISaasLogoIcon } from "./icons";
import { PreviewV2ToolBar } from "@uiview/views/PreviewV2ToolBar/PreviewV2ToolBar";
import SimpleBar from "simplebar-react";
import AddToContent from "../AddToContent";
import useFeatureTags from "@custom-hooks/useFeatureTags";
import { AYLWAYS_SHOW_OUTPUT } from "../AddToContent/conts";
import { ChatAIPage } from "@uiview/views/ChatAI/ChatAISharedPage";
import { useHomeUsePluginContainer } from "@custom-hooks/HomeUsePluginRoot";
import { PreviewCopyright } from "@uiview/views/PreviewApp/PreviewCopyright";
import { useSignal } from "@preact/signals-react";
import func from "@uikit/func";
import { usePreviewAppStore } from "@custom-hooks/HomeUsePluginRoot/usePreviewAppStore";
import { FooterUrl } from "@uiview/views/ShareAccount/FooterUrl";

function AISaasInner(props: { inOrOutSetting: (bol: boolean) => void; backPreview: () => void }) {
  const {
    thoughtOptions,
    props: aisaasProps,
    onChangeThoughts,
    addToPreview,

    onMouseEnterAISaas,
    onMouseLeaveAISaas,
  } = useAISaasContainer();

  const { previewAppAcivieId, isInHistory } = usePreviewAppStore();

  const { showAddPreview, disableAddPreview, changeDisableAddPreview } = addToPreview;
  const { showAddClickHere } = useFeatureTags();
  const {
    saasAndThinkState: { saasUIDataRef, saasUIData },
  } = useHomeUsePluginContainer();

  const api = new Api(false);
  const uploadLoge = useSignal("");
  const logoLoading = useSignal(false);

  const isChatAI = saasUIDataRef.current?.v2App?.type === "chat_ai";
  const PreviewBtnGroup = useMemo(() => {
    return (
      <div className={css["preview-btn-group"]}>
        <span
          className={css[disableAddPreview ? "preview-btn-add-content" : "preview-btn-done"]}
          onClick={changeDisableAddPreview}
        >
          {disableAddPreview && (
            <img
              src={`${settings.S3CDN}${settings.viewAssetsPath}add-icon-green.png`}
              alt=""
              style={{ paddingRight: "10px" }}
            />
          )}
          {disableAddPreview ? "Add Content" : "Done"}
        </span>
      </div>
    );
    // eslint-disable-next-line
  }, [disableAddPreview]);

  const Header = (
    <div className="aisass-head">
      <PreviewHeaderView backPreview={props.backPreview} inOrOutSetting={props.inOrOutSetting} />
    </div>
  );

  const Footer = <div className={css["aiSaas-preview-row"]}>{showAddPreview ? PreviewBtnGroup : null}</div>;

  const isMobile = window.navigator.userAgent.includes("Mobile");
  const showInfo = !isMobile && !!thoughtOptions.length;

  const AISaasCopyright = (
    <div>
      {showAddClickHere && (
        <AddToContent id={AYLWAYS_SHOW_OUTPUT} className={css.bottomAddToContent} type="output" isAlwaysShow />
      )}
      <FooterUrl showInfo={showInfo} className={css.aiSaasAppFooterUrl} />
    </div>
  );

  const initializationLogo = async () => {
    uploadLoge.value = "";
    const url = saasUIData?.settings?.logoImg || "";
    if (saasUIData.id === previewAppAcivieId && !func.isEmpty(url)) {
      try {
        logoLoading.value = true;
        const { fileUrl } = await api.getByCustomType(`/api/me/upload/im?url=${url}`, "blob");
        uploadLoge.value = fileUrl || "";
      } catch (error) {
      } finally {
        logoLoading.value = false;
      }
    }
  };

  useEffect(() => {
    initializationLogo();
    // eslint-disable-next-line
  }, [saasUIData?.settings?.logoImg]);

  useEffect(() => {
    if (isInHistory) {
      // 组件离开
      uploadLoge.value = "";
    }
  }, [isInHistory]);

  const DefaultLogo = () => {
    return logoLoading.value ? <LoadingOutlined className={css.logoLoading} /> : <AISaasLogoIcon />;
  };

  return (
    <AISaasLayout
      header={Header}
      footer={Footer}
      className={css["AISaas-wrap"]}
      onMouseEnter={onMouseEnterAISaas}
      onMouseLeave={onMouseLeaveAISaas}
    >
      <div className={css["AISaas-background"]}></div>
      {/* TIP: simple bar 为了控制 windows和 mac上滚动条一致, 让左右两侧能够显示出滑块, 如果不需要滑块可直接将 simple 替换普通 div */}
      <SimpleBar className={css["AISaas-main"]}>
        <div data-testid="AiSaasContent" className={css.aiSaasContent}>
          {isChatAI ? (
            <ChatAIPage />
          ) : (
            <>
              <div className={css["AISaas-logo"]}>
                {func.isEmpty(uploadLoge.value) ? (
                  <DefaultLogo />
                ) : (
                  <img className={css.logoBoxImg} src={uploadLoge.value} alt="" />
                )}
              </div>
              <div className={css.AISaasContent}>
                <AISaasHeader />
                <AiSaasOutputList thoughtOptions={thoughtOptions} onChangeThoughts={onChangeThoughts} />
                {AISaasCopyright}
                <PreviewV2ToolBar />
              </div>
            </>
          )}
        </div>
      </SimpleBar>
    </AISaasLayout>
  );
}

export function AISaasPreview(
  props: AISaas.AISaasStoreProps & { inOrOutSetting: (bol: boolean) => void; backPreview: () => void }
) {
  return (
    <AISaasProvider initialState={props}>
      <AISaasInner inOrOutSetting={props.inOrOutSetting} backPreview={props.backPreview} />
    </AISaasProvider>
  );
}
